import { Pagination } from "@mantine/core";
import { useTableProvider } from "../../providers";

export function TablePaginationComponent() {
  const { totalPage, changePage } = useTableProvider();

  return <Pagination total={totalPage} onChange={changePage} />;
}
